export default "__VITE_ASSET__2jspAzx3__"